import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { Router, RouterModule } from '@angular/router';
import { AdministrarTiendaService } from '@core/services/tienda/administrar-tienda.service';
import { decrypt } from '@core/utils/EncryptUtil'; // Importar función de desencriptación
import {  MatMenuModule } from '@angular/material/menu';
import { CdkMenuModule } from '@angular/cdk/menu';
import { UtilService } from '@shared/services/util.service';
import { AuthService } from '@core/services/auth.service';
import { Subject, takeUntil } from 'rxjs';
import { DeviceService } from '@core/services/device.service';

@Component({
  selector: 'app-sidenav',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatListModule, RouterModule, CdkMenuModule],
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
})
export class SidenavComponent implements OnInit {
  idTienda: string = '';
  idUsuario: string = '';
  nombreTienda: string = '';
  nombreResponsable: string = '';
  direccionTienda: string = '';
  email: string = '';
  rol: string = '';
  descNombreRol: string = '';
  idRolUsuario: number = 0; // Propiedad para almacenar el rol del usuario
  isMobile = false;

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private administrarTiendaService: AdministrarTiendaService,
    private authSvc: AuthService,
    private utilSvc: UtilService,
    private deviceService: DeviceService
  ) {}

  ngOnInit(): void {
    this.deviceService.isMobile$.pipe(takeUntil(this.destroy$)).subscribe((mob) => {
      this.isMobile = mob;
    });
    this.idTienda = this.administrarTiendaService.idTienda;
    this.obtenerRolUsuario(); // Obtener el rol del usuario
    this.obtenerDataUsuario();
  }

  isActive(route: string): boolean {
    return this.router.url === route;
  }

  /*
  id: decodedToken?._id,
  dni: decodedToken?.dni,
  email: decodedToken?.email,
  nombre: decodedToken?.firstName + ' ' + decodedToken?.lastName,
  rolApp: decodedToken?.roles ? decodedToken?.roles[0].name : '',
  idRolApp: decodedToken?.roles ? decodedToken?.roles[0].internalId : 0,
  */

  private obtenerDataUsuario(): void {
    const encryptedUsuario = localStorage.getItem('usuarioGarantia');
    if (encryptedUsuario) {
      try {
        const usuario = decrypt<{ email: string, nombre: string, id: string }>(encryptedUsuario);
        this.nombreResponsable = usuario!.nombre || ""; // Asignar el rol si existe
        this.email = usuario!.email || ""; // Asignar el rol si existe
        this.idUsuario = usuario?.id || "";

        console.log(usuario)
      } catch (error) {
        console.error('Error al desencriptar el usuario:', error);
      }
    } else {
      console.warn('No se encontró información del usuario en localStorage.');
    }
  }

  private obtenerRolUsuario(): void {
    const encryptedUsuario = localStorage.getItem('tiendaGarantia');
    if (encryptedUsuario) {
      try {
        const usuario = decrypt<{ internalId: number, nombreTienda: string, direccion: string, rol: string, descNombre: string}>(encryptedUsuario);
        this.idRolUsuario = usuario!.internalId || 0; // Asignar el rol si existe
        this.rol = usuario!.rol || "0"; // Asignar el rol si existe
        this.descNombreRol = usuario!.descNombre || "0"; // Asignar el rol si existe
        this.nombreTienda = usuario!.nombreTienda || ""; // Asignar el rol si existe
        this.direccionTienda = usuario!.direccion || ""; // Asignar el rol si existe

        console.log(usuario)
      } catch (error) {
        console.error('Error al desencriptar el usuario:', error);
      }
    } else {
      console.warn('No se encontró información del usuario en localStorage.');
    }
  }

  ocultarSidenav(){
    this.utilSvc.openSidenav({ valueBtn: false, valueSide: false });
  }

  // Método para verificar si el usuario tiene un rol específico
  hasRole(role: number): boolean {
    return this.idRolUsuario === role;
  }

  onLogout(): void {
    this.utilSvc.openSidenav({ valueBtn: false, valueSide: false });
    this.authSvc.logout();
  }
}
